import React from "react";
import SearchField from "./SearchField";

const TableSearch = ({ value = "", onChange = () => {} }) => {
  return (
    <div dataTest="datatable-search" className="d-flex align-items-center justify-content-end">
      <div dataTest="datatable-input" className="mdb-datatable-filter flex-row">
        <SearchField
          isAvField={false}
          className="form-control form-control-sm ml-0 my-1"
          type="text"
          placeholder="Search"
          aria-label="Search"
          onChange={(e) => onChange(e.target.value)}
          value={value || ""}
        />
      </div>
    </div>
  );
};

export default TableSearch;
